import React, { useState } from "react";
import { Box, Grid, TextField, Button, Paper, Typography } from "@mui/material";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";

function ChangePassword() {
  const { t } = useTranslation();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!oldPassword.trim() || !newPassword.trim()) {
      return toast.error(t("changePassword.errors.fillAllFields"));
    }

    const confirm = await swal({
      title: t("changePassword.title"),
      text: "Are you sure you want to change your password?",
      icon: "warning",
      buttons: ["Cancel", "Yes, Change"],
      dangerMode: true,
    });

    if (!confirm) return;

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}admin/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ oldPassword, newPassword }),
      });

      const result = await res.json();
      if (result.code === 200) {
        toast.success(result.message || t("changePassword.success.updated"));
        setOldPassword("");
        setNewPassword("");
      } else {
        toast.error(result.message || t("changePassword.errors.failed"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("changePassword.errors.somethingWentWrong"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >
      <Paper elevation={3} sx={{ p: 4, width: "100%", maxWidth: 500 }}>
        <Typography variant="h6" mb={3} align="center">
          {t("changePassword.title")}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="password"
                label={t("changePassword.labels.oldPassword")}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                type="password"
                label={t("changePassword.labels.newPassword")}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" disabled={loading}>
                {loading
                  ? t("changePassword.buttons.updating")
                  : t("changePassword.buttons.update")}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
}

export default ChangePassword;
